"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFieldContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _device = require("b2b-components/utils/device");
var _SearchField = require("./SearchField");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchFieldContainer = exports.SearchFieldContainer = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    onSubmit,
    onInputChange,
    onClearButtonClick,
    onInputKeyDown,
    onScanCodeButtonClick,
    value,
    isLoading,
    placeholder,
    deviceType,
    dataAttributes,
    className,
    submitButtonDataAttributes,
    closeButtonDataAttributes
  } = _ref;
  const hasScanCodeButton = !!onScanCodeButtonClick && !(value.length > 0) && (0, _device.isMobile)(deviceType);
  const inputRef = (0, _react.useRef)(null);
  _react.default.useImperativeHandle(ref, () => inputRef?.current);
  const handleSubmit = e => {
    e.preventDefault();
    onSubmit();
  };
  const handleClick = e => {
    e.stopPropagation();
  };
  const handleScanCodeButtonClick = e => {
    e.stopPropagation();
    onScanCodeButtonClick?.();
  };
  const handleClearButtonClick = e => {
    e.stopPropagation();
    onClearButtonClick();
    inputRef?.current?.focus?.();
  };
  const handleInputKeyDown = e => {
    onInputKeyDown?.(e);
  };
  return /*#__PURE__*/_react.default.createElement(_SearchField.SearchField, {
    onClick: handleClick,
    onSubmit: handleSubmit,
    onInputChange: onInputChange,
    onInputKeyDown: handleInputKeyDown,
    onClearButtonClick: handleClearButtonClick,
    onScanCodeButtonClick: handleScanCodeButtonClick,
    hasScanCodeButton: hasScanCodeButton,
    value: value,
    isLoading: isLoading,
    placeholder: placeholder,
    deviceType: deviceType,
    inputRef: inputRef,
    dataAttributes: dataAttributes,
    className: className,
    submitButtonDataAttributes: submitButtonDataAttributes,
    closeButtonDataAttributes: closeButtonDataAttributes
  });
});
SearchFieldContainer.displayName = 'SearchFieldContainer';
//# sourceMappingURL=SearchFieldContainer.js.map